import { getApiConfig } from './../../../utilities';
const {get, post} = getApiConfig('ProjectScope/');

const actionTypePrefix = "project-scope/new-feature-group";
export const newFeatureGroupActionTypes = {
  LOAD: `${actionTypePrefix}/load`,
  ADD: `${actionTypePrefix}/add`,
  CLEAR: `${actionTypePrefix}/clear`
};

export const addNewFeatureGroup = (name, description, image) => {
  return (dispatch, getState) => {
    return new Promise(resolve => {
      post([{
        groupName: name,
        description: description,
        customImageUrl: image,
        enabled: false,
        visible: false,
        customDisplayName: ''
      }], '/feature-groups-save');
      dispatch({
        type: newFeatureGroupActionTypes.ADD,
        payload: {
          name, 
          description, 
          image
        }
      });
      resolve();
    }).catch(console.error);
  }
};

export const loadNewFeatureGroups = () => {
  return (dispatch, getState) => {
    return new Promise(resolve => {

    }).catch(console.error);
  }
};
